namespace Portico.Models.Enterprise {

	export interface IAccountSession {
		id: number;
		sessionDate: Date;
		documentId: number;
		entityId: number;
		surveyId: number;
		surveySessionId: number;

		diagnoses: Diagnosis[];
		diagnosisSession: DiagnosisSession;
		surveySession: SurveySession;

		//getSurveySessionAnswers: (questionId: number) => SurveySessionAnswer[];
		//isSurveyAnswer: (questionId: number, answerId: number) => boolean;
    }

	export class AccountSession implements IAccountSession {
		id: number;
		sessionDate: Date;
		documentId: number;
		entityId: number;
		surveyId: number;
		surveySessionId: number;

		diagnoses: Diagnosis[];
		diagnosisSession: DiagnosisSession;
		surveySession: SurveySession;

		constructor(obj?: IAccountSession | any) {
			this.id = null;
			this.sessionDate = null;
			this.documentId = null;
			this.entityId = null;
			this.surveyId = null;
			this.surveySessionId = null;

			this.diagnoses = null;
			this.diagnosisSession = null;
			this.surveySession = null;

            if (obj) {
				this.id = obj.id || obj.sessionId || null;

				if (obj.sessionDate) {
					this.sessionDate = new Date(obj.sessionDate.toString());
				}

				this.documentId = obj.documentId || null;
				this.entityId = obj.entityId || null;
				this.surveyId = obj.surveyId || null;
				this.surveySessionId = obj.surveySessionId || null;

				if (obj.diagnoses) {
					this.diagnoses = [];

					for (const diagnosis of obj.diagnoses) {
						this.diagnoses.push(new Diagnosis(diagnosis));
					}
				}

				if (obj.diagnosisSession) {
					this.diagnosisSession = new DiagnosisSession(obj.diagnosisSession);
				}

				if (obj.surveySession) {
					this.surveySession = new SurveySession(obj.surveySession);
				}
            }
        }

		//getSurveySessionAnswers(questionId: number): SurveySessionAnswer[] {
		//	if (this.surveySession) {
		//		return this.surveySession.getSurveySessionAnswers(questionId);
		//	}

		//	return [];
		//}

		//isSurveyAnswer(questionId: number, answerId: number): boolean {
		//	if (this.surveySession) {
		//		return this.surveySession.isSurveyAnswer(questionId, answerId);
		//	}

		//	return false;
		//}
    }
}
